module.exports = __webpack_public_path__ + "img/azkic-cgnrh.f7b21f9e.png";